import Tooltip from '@paradigm/design-system/src/components/Tooltip';

const StrategyDetailsBuyerTooltip = () => (
  <Tooltip
    id="strategy-details-buyer"
    tooltipContent={
      <>
        <p>Strategies are displayed in the table from a buyer’s perspective.</p>
        <p>
          <b>“Buying”</b> the strategy (lifting the Maker’s offer) will result
          in executing each leg in the same direction as per it’s Action in the
          table below.
        </p>
        <p className="mb-0">
          <b>“Selling”</b> the strategy (hitting the Maker’s Bid) will result in
          executing each leg in the opposite direction of it’s Action in the
          table below
        </p>
      </>
    }
  />
);

export default StrategyDetailsBuyerTooltip;
